(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/numberlist-events.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/numberlist-events.js');

'use strict';

function events() {
  const cache = {
    all: []
  };
  return {
    trigger(event, data) {
      const subscribers = cache[event];
      let len = subscribers ? subscribers.length : 0;
      while (len--) {
        const _subscribers$len = subscribers[len],
          context = _subscribers$len.context,
          callback = _subscribers$len.callback;
        callback.call(context, data);
      }
      if (event !== 'all' && cache.all.length) {
        this.trigger('all', {
          event,
          data
        });
      }
    },
    on(event, callback, context) {
      if (!cache[event]) cache[event] = [];
      cache[event].push({
        callback,
        context
      });
    },
    off(event, context) {
      const subscribers = cache[event];
      let len = subscribers ? subscribers.length : 0;
      while (len--) {
        const subscriber = subscribers[len];
        if (subscriber.context === context) {
          subscribers.splice(len, 1);
        }
      }
    }
  };
}
svs.numbergames.game_model.utils.numberlist_events = events;

 })(window);